import { domainGroupService } from '../../helpers/services/domainGroup.service';
import i18n from '@/i18n'
import router from '@/router/index'
import { sharedHelper } from '@/utils'

export const state = {
  list: {
    data: [],
    pagination: {
      pageNumber: 0,
      pageSize: 0,
      lastPage: 0,
      tableRowsCount: 0
    }
  },
  details: {},
  candidates: [],
  status: {}
}

export const DOMAIN_GROUP_MODULE = "domainGroup";

// define action
export const GET_ALL_DOMAIN_GROUPS = 'getAllDomainGroups';
export const GET_DOMAIN_GROUP = 'getDomainGroup';
export const CREATE_DOMAIN_GROUP = 'createDomainGroup';
export const UPDATE_DOMAIN_GROUP = 'updateDomainGroup';
export const UPDATE_DOMAIN_GROUP_STATUS = 'updateDomainGroupStatus';
export const UPDATE_DOMAIN_GROUP_DOMAINS = 'updateDomainGroupDomains';
export const GET_DOMAIN_GROUP_CANDIDATES = 'getDomainGroupCandidates';

// define mutation
const REQUESTING = "requesting";
const MEMBERS_REQUESTING = "membersRequesting";
const ALL_DOMAIN_GROUP_SUCCESS = "allDomainGroupSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_DOMAIN_GROUP_SUCCESS = "getDomainGroupSuccess";
const CREATE_UPDATE_DOMAIN_GROUP_SUCCESS = "createUpdateDomainGroupSuccess";
const UPDATE_DOMAIN_GROUP_DOMAINS_SUCCESS = "updateDomainGroupDomainsSuccess";
const DOMAIN_GROUP_CANDIDATES_SUCCESS = "domainGroupCandidatesSuccess";

export function mapDomainGroup(x) {
  return {
    id: x.uuid,
    name: x.name,
    slug: x.slug,
    countryCode: x.country_code,
    isActive: x.is_active == 1,
    domainsCount: x.domains_count,
    ownerUuid: x.owner ? x.owner.uuid : null,
    ownerName: x.owner ? x.owner.name : null,
    ownerEmail: x.owner ? x.owner.email : null,
    // Only present on GET show / PUT domains.
    domains: x.domains ? x.domains.map((d) => {
      return {
        uuid: d.uuid,
        domain: d.domain,
        countryCode: d.country_code,
        priority: d.priority,
        lastStatus: d.last_status,
        isActive: d.is_active == 1
      }
    }) : [],
    playerLink: x.player_link || null,
    createdAt: x.created_at,
    updatedAt: x.updated_at
  }
}

function mapCandidate(x) {
  return {
    uuid: x.uuid,
    domain: x.domain,
    countryCode: x.country_code,
    lastStatus: x.last_status,
    priority: x.priority,
    domainGroupUuid: x.domain_group ? x.domain_group.uuid : null,
    domainGroupName: x.domain_group ? x.domain_group.name : null
  }
}


export const actions = {

  // eslint-disable-next-line no-unused-vars
  [GET_ALL_DOMAIN_GROUPS]({ commit }, { filter }) {
    domainGroupService
      .getAllDomainGroups(filter)
      .then(
        (result) => {
          commit(ALL_DOMAIN_GROUP_SUCCESS, { data: result })
        },
        (error) => {
          let message = sharedHelper.getErrorMessage(error);
          sharedHelper.alertErrorMessage(message, error.response.data.code)
          commit(FAILURE);
        }
      )
  },

  // eslint-disable-next-line no-unused-vars
  [GET_DOMAIN_GROUP]({ commit }, { uuid }) {
    domainGroupService
      .getDomainGroup(uuid)
      .then(
        (result) => {
          commit(GET_DOMAIN_GROUP_SUCCESS, result)
        },
        (error) => {
          let message = sharedHelper.getErrorMessage(error);
          sharedHelper.alertErrorMessage(message, error.response.data.code)
          commit(FAILURE);
        }
      );
  },

  // eslint-disable-next-line no-unused-vars
  [CREATE_DOMAIN_GROUP]({ commit }, { data }) {
    commit(REQUESTING);
    domainGroupService
      .createDomainGroup(data)
      .then(
        // eslint-disable-next-line no-unused-vars
        (result) => {
          var message = i18n.t("message.createXSuccess", [i18n.t('module.domainGroup')]);
          sharedHelper.alertSuccessMessage(message)
          commit(CREATE_UPDATE_DOMAIN_GROUP_SUCCESS);
        },
        (error) => {
          let message = sharedHelper.getErrorMessage(error);
          sharedHelper.alertErrorMessage(message, error.response.data.code)
          commit(FAILURE);
        }
      )
  },

  // eslint-disable-next-line no-unused-vars
  [UPDATE_DOMAIN_GROUP]({ commit }, { data }) {
    commit(REQUESTING);
    domainGroupService
      .updateDomainGroup(data.id, data)
      .then(
        // eslint-disable-next-line no-unused-vars
        (result) => {
          var message = i18n.t("message.updateXSuccess", [i18n.t('module.domainGroup')]);
          sharedHelper.alertSuccessMessage(message)
          commit(CREATE_UPDATE_DOMAIN_GROUP_SUCCESS);
        },
        (error) => {
          let message = sharedHelper.getErrorMessage(error);
          sharedHelper.alertErrorMessage(message, error.response.data.code)
          commit(FAILURE);
        }
      );
  },

  // eslint-disable-next-line no-unused-vars
  [UPDATE_DOMAIN_GROUP_STATUS]({ dispatch, commit }, { filter, data }) {
    domainGroupService.updateDomainGroupStatus(data)
      .then(
        // eslint-disable-next-line no-unused-vars
        (result) => {
          var message = i18n.t('message.updateStatusSuccess');
          sharedHelper.alertSuccessMessage(message)
          dispatch(GET_ALL_DOMAIN_GROUPS, { filter })
        },
        (error) => {
          let message = sharedHelper.getErrorMessage(error);
          sharedHelper.alertErrorMessage(message, error.response.data.code)
          commit(FAILURE);
        }
      )
  },

  // Saves membership and stays on the page: the response is the refreshed
  // group, so details are updated in place and candidates are reloaded.
  // eslint-disable-next-line no-unused-vars
  [UPDATE_DOMAIN_GROUP_DOMAINS]({ dispatch, commit }, { uuid, domains }) {
    commit(MEMBERS_REQUESTING);
    domainGroupService
      .updateDomainGroupDomains(uuid, domains)
      .then(
        (result) => {
          var message = i18n.t("message.updateXSuccess", [i18n.t('label.members')]);
          sharedHelper.alertSuccessMessage(message)
          commit(UPDATE_DOMAIN_GROUP_DOMAINS_SUCCESS, result);
          dispatch(GET_DOMAIN_GROUP_CANDIDATES, { uuid })
        },
        (error) => {
          let message = sharedHelper.getErrorMessage(error);
          sharedHelper.alertErrorMessage(message, error.response.data.code)
          commit(FAILURE);
        }
      );
  },

  // eslint-disable-next-line no-unused-vars

  // eslint-disable-next-line no-unused-vars
  [GET_DOMAIN_GROUP_CANDIDATES]({ commit }, { uuid }) {
    domainGroupService
      .getDomainGroupCandidates(uuid)
      .then(
        (result) => {
          commit(DOMAIN_GROUP_CANDIDATES_SUCCESS, result)
        },
        (error) => {
          let message = sharedHelper.getErrorMessage(error);
          sharedHelper.alertErrorMessage(message, error.response.data.code)
          commit(FAILURE);
        }
      );
  },

};

export const mutations = {
  [ALL_DOMAIN_GROUP_SUCCESS](state, { data }) {
    let d = data.data

    state.list.data = []
    state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

    if (data.success) {
      let list = []

      d.forEach((x) => {
        list.push(mapDomainGroup(x))
      })

      state.list.data = list
    }
  },
  [SUCCESS](state) {
    state.status = {};
  },
  [FAILURE](state) {
    state.status = {};
  },
  [REQUESTING](state) {
    state.status = { processing: true };
  },
  [MEMBERS_REQUESTING](state) {
    state.status = { savingMembers: true };
  },
  [CREATE_UPDATE_DOMAIN_GROUP_SUCCESS](state) {
    state.status = {};
    router.push({ name: "Domain-group-listing" })
  },
  [GET_DOMAIN_GROUP_SUCCESS](state, data) {
    state.details = mapDomainGroup(data.data)
  },
  [UPDATE_DOMAIN_GROUP_DOMAINS_SUCCESS](state, data) {
    state.status = {};
    state.details = mapDomainGroup(data.data)
  },
  [DOMAIN_GROUP_CANDIDATES_SUCCESS](state, data) {
    state.candidates = (data.data || []).map(mapCandidate)
  },
}
